import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import BackendApiClient from '../../services/api/BackendApiClient';
import { PromoComponentInterface } from '../../services/exports/Interfaces';
import { PROMO_CODE_DISCOUNT_TYPES, PROMO_CODE_TYPES } from '../../services/exports/Constants';

export type PromoCodeData = {
  id: number;
  code: string;
  type: PROMO_CODE_TYPES;
  discount?: number;
  discount_type: PROMO_CODE_DISCOUNT_TYPES;
  expires_at: string;
  components: PromoComponentInterface[];
  image_url?: string;
};

export enum PromoCodesApiSliceTags {
  PromoCodes = 'PromoCodes',
}

export const promoCodesApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'promoCodesApiSlice',
  tagTypes: Object.values(PromoCodesApiSliceTags),
  endpoints: (build) => ({
    getPromoCodes: build.query<PromoCodeData[], number>({
      queryFn: (companyId) =>
        BackendApiClient.request({
          method: 'GET',
          url: `/companies/${companyId}/promo-codes`,
        }).then((res) => {
          if (res.success) {
            return { data: res.response.data.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
      providesTags: [PromoCodesApiSliceTags.PromoCodes],
    }),
  }),
});

export const { useGetPromoCodesQuery } = promoCodesApiSlice;
